var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "#282C3F",
    strokeWidth: 1.14,
    fill: "#FFF",
    x: 0.57,
    y: 0.57,
    width: 14.86,
    height: 14.86,
    rx: 1.7,
    fillRule: "evenodd",
    fillOpacity: 0.5,
    className: "itemComponents-base-inactiveProduct itemComponents-base-reduceOpacity"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselect);
export default __webpack_public_path__ + "static/media/unselect.7bc8d185253cf3bf9471418c56a1ee9d.svg";
export { ForwardRef as ReactComponent };